import { path, createCachedSelector, defaultKeySelector } from '@cbridge-utils/redux';
import { IStream } from '../stream.interface';
import { streamStoreSelector } from '../stream.selector';

export const streamListSelector = createCachedSelector(
  [
    path(streamStoreSelector).data(),
    path(streamStoreSelector).listNetworkStatus(),
  ],
  (data, networkStatus) => {
    const list: IStream[] = Object.values(data);
    return {
      list,
      networkStatus,
    };
  },
)({
  keySelector: defaultKeySelector,
});
